import { render, staticRenderFns } from "./pf-columns-action.vue?vue&type=template&id=04aa2315"
import script from "./pf-columns-action.vue?vue&type=script&lang=js"
export * from "./pf-columns-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports